import { render } from "./ChatDrawer.vue?vue&type=template&id=11af5266&scoped=true"
import script from "./ChatDrawer.vue?vue&type=script&lang=js"
export * from "./ChatDrawer.vue?vue&type=script&lang=js"

import "./ChatDrawer.vue?vue&type=style&index=0&id=11af5266&lang=less&scoped=true"
import "./ChatDrawer.vue?vue&type=style&index=1&id=11af5266&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11af5266"]])

export default __exports__